<template>
	<div class="layout-footer">
		<img alt="Logo" :src="footerImage()" height="50" class="mr-2" />
		by
		<span class="font-medium ml-2">TravelSafe</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter",
		methods: {
			footerImage() {
				return this.$appState.darkTheme ? 'images/download.png' : 'images/download.png';
			}
		},
		computed: {
			darkTheme() {
				return this.$appState.darkTheme;
			}
		}
	}
</script>
<style>
.layout-topbar,.layout-sidebar{
  background-color:#173EA3 !important;
}
.layout-topbar .layout-topbar-button{
  color: white;
}
.layout-menu li a{
  color: white;
}
.layout-menu li a:hover{
  color:black;
}

body{
	background-color: #EFF3F8;
}
/* .layout-main-container{
    background-color: black !important;
}
.layout-wrapper{
    background-color: black !important;
} */
</style>
